import Event from "@/services/Event";
import EnrollmentTeamCard from "@/components/Admin/Enrollment/TeamCard";
import EnrollmentJudgeCard from "@/components/Admin/Enrollment/JudgeCard";
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";

import EnrollmentChip from "@/components/Enrollments/Chip";

import getJudgeTypes from "@/helpers/events/getJudgeTypes";

export default {
  name: "AdminEvent",

  props: ["id"],

  components: {
    EnrollmentTeamCard,
    EnrollmentJudgeCard,
    EnrollmentChip,
  },

  data: () => ({
    // loaders
    loading: true,
    // data
    event: {},
    enrollments: [],
    // filters
    query: {
      q: "",
      situation: null,
    },
  }),

  created() {
    this.$store.dispatch("getUserInfo", () => {
      this.$store.dispatch("updateMe");
    });
    this.fetchEvent();
    this.fetchEnrollments();
  },

  watch: {
    query: {
      handler() {
        if (this.isQueryClear) {
          this.$router.replace({ query: {} });
        }
      },
      deep: true,
    },
  },

  computed: {
    ...mapState(["enrollmentStatuses", "community"]),
    ...mapGetters(["isSuboperator"]),

    teams() {
      return this.enrollments.filter((enrollment) => enrollment.kind == "team");
    },
    judges() {
      return this.enrollments.filter(
        (enrollment) => enrollment.kind == "judge",
      );
    },

    filteredTeams() {
      return this.teams
        .filter((t) =>
          !this.query.situation
            ? true
            : t.situation.status._id == this.query.situation,
        )
        .filter((t) =>
          !this.query.q
            ? true
            : t.entity.name.toLowerCase().indexOf(this.query.q.toLowerCase()) >=
              0,
        );
    },

    filteredJudges() {
      return this.judges
        .filter((t) =>
          !this.query.situation
            ? true
            : t.situation.status._id == this.query.situation,
        )
        .filter((t) =>
          !this.query.q
            ? true
            : t.entity.name.toLowerCase().indexOf(this.query.q.toLowerCase()) >=
              0,
        );
    },
  },

  methods: {
    goBack() {
      return this.$router.back();
    },

    eventDraw() {
      this.$router.push({
        name: "admin.event.draw",
        params: { id: this.event._id },
      });
    },

    isQueryClear() {
      return !Object.values(this.query).some((val) => val);
    },

    fetchEvent() {
      Event.get(this.id).then(
        (res) => {
          this.event = res.data;
        },
        () => {},
      );
    },

    fetchEnrollments() {
      this.loading = true;
      Event.enrollments(this.id, { includes: ["entity"] }).then(
        (res) => {
          this.loading = false;
          this.enrollments = res.data.reverse();
        },
        () => {
          this.loading = false;
        },
      );
    },

    editEnrollment(enrollment) {
      if (!_.get(enrollment, "_id")) {
        return;
      }

      this.$router.push({
        name: "submit",
        params: {
          cache: enrollment,
          modelId: enrollment._id,
          impersonate: true,
          kind: enrollment.kind,
        },
      });
    },

    findJudgeType(type) {
      return _.find(getJudgeTypes(this.community), { _id: type }, {}).label;
    },

    exportEvent(kind) {
      this.loading = true;

      Event.export(this.event._id, kind)
        .then((r) => {
          this.loading = false;
          const fileURL = window.URL.createObjectURL(new Blob([r.data]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          const fileName = `${this.event.name}-${moment().format(
            "hh:mm-DD-MM",
          )}.csv`;
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminEvent/AdminEvent.js